const gridItems = (editor) => {

    editor.BlockManager.add(`grid-items`, {
        label: `Grid Posts`,
        category: 'List Items',
        content: `
                <div dataItems="getAllCards" class='wabli-grid-items mx-auto p-2'>
                    <div dataitem=true class="card mb-4">
                        <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/850x350/dee2e6/6c757d.jpg" alt="..." /></a>
                        <div class="card-body">
                            <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                            <h2 dataCardTitle=true class="card-title">Featured Post Title</h2>
                            <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>
                            <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div dataitem=true class="card mb-4">
                                <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                <div class="card-body">
                                    <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                    <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                    <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                    <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                </div>
                            </div>
                            <div dataitem=true class="card mb-4">
                                <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                <div class="card-body">
                                    <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                    <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                    <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                    <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div dataitem=true class="card mb-4">
                                <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                <div class="card-body">
                                    <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                    <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                    <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                    <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                </div>
                            </div>
                            <div dataitem=true class="card mb-4">
                                <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                <div class="card-body">
                                    <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                    <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                    <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                    <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
                    .wabli-grid-items{
                        max-width: 1200px;
                    }
                </style>
            `,
        attributes: { class: 'fa fa-th' }
    });
}

export default gridItems;